import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';

export function asError(errorResponse: unknown): Error {
  return errorResponse instanceof Error ? errorResponse : new Error(String(errorResponse));
}

export function requestWithResponse<T = any>(
  request: any,
  onSuccess: (response: T) => void,
  onError: (error: any) => any,
  onSubscription?: (subscription: Subscription) => void
): Promise<T> {
  return new Promise((resolve, reject) => {
    const subscription = request.pipe(map((objects: T) => objects)).subscribe({
      next: (response: T) => {
        onSuccess(response);
        resolve(response);
      },
      error: (errorResponse: any) => {
        const failure = onError(errorResponse);
        reject(asError(failure ?? errorResponse));
      }
    });
    onSubscription?.(subscription);
  });
}

export function requestWithFallback<T = any>(request: any, fallback: T, onSuccess?: (response: T) => void): Promise<T> {
  return new Promise(resolve => {
    request.subscribe({
      next: (response: T) => {
        if (onSuccess) onSuccess(response);
        resolve(response);
      },
      error: () => resolve(fallback)
    });
  });
}

export function requestWithMappedResponse<T, R>(
  request: any,
  mapResponse: (response: T) => R,
  onError: (error: any) => Error
): Promise<R> {
  return new Promise((resolve, reject) => {
    request.subscribe({
      next: (response: T) => resolve(mapResponse(response)),
      error: (errorResponse: any) => reject(onError(errorResponse))
    });
  });
}
